// extracted by mini-css-extract-plugin
export default {"container":"style_container__1L-++","small":"style_small__cOJcQ","h":"style_h__PuSaz","m":"style_m__zZCAb","l":"style_l__Avoif"};